import { render } from "./BookingFormComponent.vue?vue&type=template&id=a2fdaf9a&scoped=true"
import script from "./BookingFormComponent.vue?vue&type=script&lang=ts"
export * from "./BookingFormComponent.vue?vue&type=script&lang=ts"

import "./BookingFormComponent.vue?vue&type=style&index=0&id=a2fdaf9a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a2fdaf9a"

export default script